// extracted by mini-css-extract-plugin
export default {"section":"global_section__5iUPP","sectionTitle":"global_sectionTitle__i2Rih"};